import {
  CREATE_COUPON_FAILURE,
  CREATE_COUPON_REQUEST,
  GET_ALL_COUPON_REQUEST,
  GET_ALL_COUPON_SUCCESS,
  GET_ALL_COUPON_FAILURE,
  DELETE_COUPON_REQUEST,
  DELETE_COUPON_FAILURE,
  UPDATE_COUPON_REQUEST,
  UPDATE_COUPON_FAILURE,
  DELETE_COUPON_SUCCESS,
} from "./ActionType";

const initialState = {
  coupons: [],
  loading: false,
  error: "",
};

export const couponReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_COUPON_REQUEST:
      return { ...state, loading: true };

    case CREATE_COUPON_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_COUPON_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_COUPON_SUCCESS:
      return { ...state, loading: false, error: "", coupons: action.payload };

    case GET_ALL_COUPON_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_COUPON_REQUEST:
      return { ...state, loading: true };

    case DELETE_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        coupons: state.coupons?.response?.filter(cpn => cpn.id !== action.payload)  // Remove deleted category
      };

    case DELETE_COUPON_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_COUPON_REQUEST:
      return { ...state, loading: true };

    case UPDATE_COUPON_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
